import React from 'react';

const ComparisonSection = () => {
  return (
    <section className="sec" id="compare">
      <div className="shell">
        <div className="sec-head rv">
          <h2 className="h2">Should you file it yourself or use a firm?</h2>
          <p className="answer">
            You can file your own return on EmaraTax at no cost, and for a simple dormant company that is often
            reasonable. The risk sits in the positions taken in the return rather than the submission itself, and a
            wrong position usually surfaces months later, once penalties and interest have already accrued.
          </p>
        </div>

        <div className="compare-wrap rv">
          <table className="compare">
            <caption>
              Comparison of the three routes a UAE company usually considers for its Corporate Tax return.
            </caption>
            <thead>
              <tr>
                <th scope="col">&nbsp;</th>
                <th scope="col">Filing it yourself</th>
                <th scope="col">A low cost agent</th>
                <th scope="col">Standard Auditing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Typical cost</th>
                <td className="bad">No fee, plus your own time</td>
                <td className="bad">AED 300 to 600</td>
                <td className="good">
                  <span className="flag">AED 750 to 1,500 plus VAT</span>
                </td>
              </tr>
              <tr>
                <th scope="row">Small Business Relief test</th>
                <td className="bad">You apply the cumulative revenue test yourself</td>
                <td className="bad">Often assumed from the current year alone</td>
                <td className="good">Tested against this and every earlier period</td>
              </tr>
              <tr>
                <th scope="row">Free zone status</th>
                <td className="bad">You judge your own qualifying income</td>
                <td className="bad">Rarely assessed in depth</td>
                <td className="good">Substance and qualifying income reviewed</td>
              </tr>
              <tr>
                <th scope="row">Who is accountable</th>
                <td className="bad">You are</td>
                <td className="bad">Usually nobody after submission</td>
                <td className="good">A licensed firm carrying professional indemnity cover</td>
              </tr>
              <tr>
                <th scope="row">If the FTA queries it</th>
                <td className="bad">You respond alone</td>
                <td className="bad">Often uncontactable by then</td>
                <td className="good">We hold the working papers and respond</td>
              </tr>
              <tr>
                <th scope="row">Best suited to</th>
                <td className="bad">A dormant company with no transactions</td>
                <td className="bad">Simple filings where cost is the only concern</td>
                <td className="good">Trading companies, free zone entities, and anyone already late</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="support" style={{ marginTop: '22px' }}>
          If your case really is the first column, we will say so on the call. We would rather lose an AED 750 fee than
          file a return that does not need us.
        </p>
      </div>
    </section>
  );
};

export default ComparisonSection;
